<template>
  <section class="user-select-none mx-lg-0 d-flex flex-column" :class="actionLinkText ? '' : 'ml-3 mr-2'">
    <slot name="marketing-content-collection" />
    <div
      v-for="(group, index) in groups"
      :id="encodeURIComponent(group.name.replace(/\s+/g, '-').toLowerCase())"
      :ref="encodeURIComponent(group.name.replace(/\s+/g, '-').toLowerCase())"
      :key="group.id"
      class="product-group-row d-flex flex-column mb-4"
      :style="{ order: index }"
    >
      <component
        :is="!petEssentialsType ? 'ProductStyles' : 'EssentialsProductStyles'"
        :action-link-text="actionLinkText"
        :always-show-all-products="showAllTags"
        :always-show-all-tags="showAllTags"
        :group="group"
        :hide-header="hideHeader"
        :is-click-to-action-item="isClickToActionItem"
        :pet-id="petId"
        :redirect-path="redirectPath"
        v-on="$listeners"
        aria-roledescription="carousel"
        role="group"
      />
    </div>
  </section>
</template>

<script>
import ProductStyles from './ProductStyles';
import EssentialsProductStyles from './essentials/EssentialsProductStyles';

export default {
  name: 'ProductGroup',
  components: { EssentialsProductStyles, ProductStyles },
  props: {
    groups: {
      type: Array,
      required: true,
    },
    petId: {
      type: [String, Number],
      default: '',
      required: false,
    },
    showAllTags: {
      type: Boolean,
      default: false,
      required: false,
    },
    petEssentialsType: {
      type: Boolean,
      default: false,
      required: false,
    },
    actionLinkText: {
      type: String,
      required: false,
      default: null,
    },
    hideHeader: {
      type: Boolean,
      default: false,
      required: false,
    },
    isClickToActionItem: {
      type: Boolean,
      default: false,
      required: false,
    },
    redirectPath: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.product-group-row {
  margin-right: 0;
  .product-group-name {
    font-size: 2rem;
  }
}
</style>
